import { useQuery } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";

export type PublicCompany = {
  id: string;
  commonName: string;
  logoUrl: string;
};

export const usePublicCompany = (companyId: string | undefined) =>
  useQuery({
    queryKey: ["public-company", companyId],
    enabled: !!companyId,
    retry: false,
    staleTime: Infinity,
    queryFn: async () => {
      const { data } = await bffAxios.get<PublicCompany>(`/public/companies/${companyId}`);

      return data;
    },
  });
